import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

const quickLinks = [
  { name: 'Ask a Tax Question - Free', path: '/ask' },
  { name: 'IRS Notice Review', path: '/services/irs-notice' },
  { name: 'Tax Diagnostic Review', path: '/services/diagnostic' },
  { name: 'Tax Resolution', path: '/services/resolution' },
  { name: 'Tax Preparation', path: '/services/preparation' },
];

const companyLinks = [
  { name: 'About Us', path: '/about' },
  { name: 'Pricing', path: '/pricing' },
  { name: 'Blog', path: '/blog' },
  { name: 'Small Business Help', path: '/services/small-business' },
  { name: 'Truck Driver Tax Help', path: '/services/truck-driver-tax' },
  { name: 'Second Look Review', path: '/services/second-look-review' },
  { name: 'Book a Consultation', path: '/book', external: 'https://taxproanswers.setmore.com' },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-brand-navy text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_irs-notice-review/artifacts/w4s948ey_Log%20for%20TaxPro%20-%20Answers%20-ChatGPT%20Image%20Apr%2017%2C%202026%2C%2009_28_08%20AM.png"
                alt="TaxPro - Answers"
                className="h-24 w-auto rounded"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Clear answers to your tax questions. 25 years of experience helping individuals and business owners navigate tax problems with confidence.
            </p>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-white/10 rounded-md text-xs font-medium tracking-wide uppercase text-slate-300">
              25+ Years Experience
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-widest text-slate-400 mb-5">
              Services
            </h4>
            <nav className="flex flex-col gap-3">
              {quickLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-slate-300 hover:text-white transition-colors"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-widest text-slate-400 mb-5">
              Company
            </h4>
            <nav className="flex flex-col gap-3">
              {companyLinks.map((link) => (
                link.external ? (
                  <a
                    key={link.path}
                    href={link.external}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-slate-300 hover:text-white transition-colors"
                  >
                    {link.name}
                  </a>
                ) : (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="text-sm text-slate-300 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                )
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-sm uppercase tracking-widest text-slate-400 mb-5">
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <a href="tel:8555892461" className="flex items-center gap-3 text-sm text-slate-300 hover:text-white transition-colors">
                <Phone className="w-4 h-4 text-brand-green flex-shrink-0" />
                855-589-2461
              </a>
              <a href="mailto:info@taxpro-answers.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-slate-300 hover:text-white transition-colors underline cursor-pointer">
                <Mail className="w-4 h-4 text-brand-green flex-shrink-0" />
                info@taxpro-answers.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">
            &copy; {new Date().getFullYear()} TaxPro - Answers. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-xs text-slate-500 hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <span className="text-xs text-slate-500">|</span>
            <Link to="/terms" className="text-xs text-slate-500 hover:text-white transition-colors">
              Terms of Use
            </Link>
            <span className="text-xs text-slate-500">|</span>
            <p className="text-xs text-slate-500">
              This website is for informational purposes only and does not constitute legal or tax advice.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
